const TRUST_ITEMS = [
  { icon: 'ri-shield-check-fill', label: 'Licensed & Insured' },
  { icon: 'ri-medal-2-fill', label: 'GAF Certified' },
  { icon: 'ri-award-fill', label: 'Fortification Certified' },
  { icon: 'ri-file-list-3-fill', label: 'Insurance Claim Assistance' },
  { icon: 'ri-map-pin-2-fill', label: 'Gulf Coast Local Experts' },
  { icon: 'ri-home-4-fill', label: 'Residential & Commercial' },
];

export default function SectionTrustBar() {
  return (
    <div className="bg-ink relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-gold/5 via-transparent to-gold/5"></div>
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent"></div>
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/8 to-transparent"></div>
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-5">
        <div className="flex flex-wrap items-center justify-center lg:justify-between gap-5 lg:gap-0">
          {TRUST_ITEMS.map((item, i) => (
            <div key={i} className="flex items-center gap-3 group">
              <div className="w-7 h-7 flex items-center justify-center shrink-0">
                <i className={`${item.icon} text-gold text-base`}></i>
              </div>
              <span className="text-[11px] font-semibold tracking-widest uppercase text-white/55 whitespace-nowrap group-hover:text-white/80 transition-colors">
                {item.label}
              </span>
              {i < TRUST_ITEMS.length - 1 && (
                <span className="hidden xl:block w-px h-4 bg-white/10 ml-4"></span>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
